import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private http: HttpClient) { }

  public get(url:string){
    return this.http.get(url); // GET
  }

  public post({url, body}: { url: string, body: any }){
    return this.http.post(url,body); // POST
  }


  public postJava({url, body, options}: { url: string, body: any, options: any }){
    return this.http.post(url,body, options); // POST
  }


}
